{
  "contentMenu": {
    "title": "Rubrik",
    "subTitle": "Mellanrubrik",
    "bodyText": "Brödtext",
    "vignette": "Vinjett",
    "preamble": "Ingress",
    "tvListing": "Tablåinfo",
    "unorderedList": "Lista",
    "orderedList": "Punktlista",
    "searchImages": "Sök bilder",
    "factboxes": "Sök faktarutor"
  },
  "numberOfChars": "Antal tecken",
  "spelling": {
    "noSuggestions": "Inga förslag",
    "loading": "Hämtar förslag...",
    "accept": "Godkänn i den här artikeln",
    "acceptHint": "Ordet markeras inte längre här",
    "removeAccepted": "Godkänd här, ta bort",
    "removeAcceptedHint": "Ordet markeras som en rättelse igen"
  },
  "factbox": {
    "headerTitle": "Redigera faktarutans original",
    "modifiedLabel": "Originalet är från",
    "createdLabel": "Skapad",
    "lastModifiedLabel": "Senast ändrad",
    "footerTitle": "Ändringar i faktarutans text sker endast för denna artikel",
    "factboxNewTitle": "Fakta",
    "addSingleLabel": "Skapa faktaruta"
  },
  "image": {
    "captionLabel": "Text",
    "bylineLabel": "Foto"
  },
  "footer": {
    "words": "Ord",
    "numberOfWords": "Antal ord: artikel (totalt)",
    "chars": "Tecken",
    "numberOfChars": "Antal tecken: artikel (totalt)",
    "language": "Artikelspråk",
    "selection": "Markering",
    "selectionHint": "Räknar markerad text",
    "selectedWords": "Antal markerade ord",
    "selectedChars": "Antal markerade tecken"
  },
  "goToLatestVersion": "Gå till senaste versionen",
  "goToLatestVersionShort": "Senaste",
  "embargoActive": "Kan inte publiceras direkt — embargo gäller till {{time}}",
  "embargoCheckUnavailable": "Kan inte verifiera embargo. Försök igen.",
  "addRoleInfo": {
    "editorial": "Lägg till redaktionell info",
    "internal": "Lägg till intern info"
  },
  "removeInfoConfirm": "Är du säker på att du vill ta bort info?",
  "changeType": "Ändra typ",
  "changeTypeConfirm": "Är du säker på att du vill ändra typ av info?",
  "derivedFromTimelessLink": "tidlös",
  "derivedFromArticleLink": "artikel",
  "derivedFromConnector": "och",
  "derivedFromPlanningLink": "planering"
}
